import moment from "moment";
import "moment/locale/es";
import { pdfStylesV2, applyPdfColors, PDF_PAGE_MARGINS } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFBrandFooterConNumeroV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import seccionPolizasContables from "../seccionPolizasContables";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");

/**
 * La hoja de trazabilidad con el diseño moderno. Sólo cambia el envoltorio: el formato de cada
 * póliza sigue viviendo en seccionPolizasContables.js, que aquí se llama con `moderno: true`.
 *
 * Quien decide entre este archivo y el clásico es polizasTrazabilidadPdf.js, que además
 * garantiza que la empresa traiga logo: PDFHeaderV2 referencia `image: "logo"` siempre.
 */
const polizasTrazabilidadPdfV2 = (values) => {
  const polizas = values.polizas || [];
  // datosPolizas devuelve la empresa dentro de CADA póliza (todas la misma).
  const empresa = polizas.find((p) => p?.empresa)?.empresa;

  applyPdfColors(empresa);

  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;

  return {
    info: {
      title: "Pólizas de la trazabilidad",
      author: "BIWO ERP",
      subject: "Pólizas contables",
      creator: "pdfmake",
    },
    content: [
      PDFHeaderV2({
        empresa,
        // Todo el rótulo va en el título: PDFHeaderV2 pinta el folio MÁS grande que el
        // título, y aquí no hay folio que destacar.
        tituloPrincipal: "Pólizas de la trazabilidad",
        regimenFiscal: mostrarRegimen,
        // No es un comprobante fiscal: la línea "Tipo de Comprobante" no aplica.
        tipoComprobante: false,
        meta: [
          { label: "Pólizas:", value: String(polizas.length) },
          { label: "Fecha de impresión:", value: moment().locale("es").format("LL") },
        ],
      }),
      // Sin título: el encabezado ya dice qué es esta hoja.
      ...seccionPolizasContables(polizas, { titulo: null, moderno: true }),
    ],
    // datosPolizas no manda logoBiwo; PDFBrandFooterV2 cae al logo BIWO empaquetado.
    footer: PDFBrandFooterConNumeroV2(),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };
};

export default polizasTrazabilidadPdfV2;
